var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS5B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 51C39.5833 51 51 39.5833 51 25.5C51 11.4167 39.5833 0 25.5 0C11.4167 0 0 11.4167 0 25.5C0 39.5833 11.4167 51 25.5 51Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4993 29.7517C20.3668 29.7517 16.9611 29.1539 12.7493 28.335C11.7874 28.1494 9.91602 28.335 9.91602 31.1684C9.91602 36.835 16.4256 43.9183 25.4993 43.9183C34.5717 43.9183 41.0827 36.835 41.0827 31.1684C41.0827 28.335 39.2113 28.148 38.2494 28.335C34.0376 29.1539 30.6319 29.7517 25.4993 29.7517Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.752 31.167C12.752 31.167 17.002 32.5837 25.502 32.5837C34.002 32.5837 38.252 31.167 38.252 31.167C38.252 31.167 35.4186 36.8337 25.502 36.8337C15.5853 36.8337 12.752 31.167 12.752 31.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0026 24.0837C18.9586 24.0837 20.5443 21.8637 20.5443 19.1253C20.5443 16.3869 18.9586 14.167 17.0026 14.167C15.0466 14.167 13.4609 16.3869 13.4609 19.1253C13.4609 21.8637 15.0466 24.0837 17.0026 24.0837Z",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0046 24.0837C35.9606 24.0837 37.5462 21.8637 37.5462 19.1253C37.5462 16.3869 35.9606 14.167 34.0046 14.167C32.0485 14.167 30.4629 16.3869 30.4629 19.1253C30.4629 21.8637 32.0485 24.0837 34.0046 24.0837Z",
    fill: "#664500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS5B);
export default __webpack_public_path__ + "static/media/s5b.757b1f34fa63604ea77908a4578de8e9.svg";
export { ForwardRef as ReactComponent };